import { Modal } from '@/components/Modal'

import { ExportOrderSource } from '..'
import { modalId } from '../hooks/useController'
import { Content } from './Content'

type Props = {
  source: ExportOrderSource
  orderStepIds: string[]
  orderSteps: uui.domain.client.rm.ExtendedOrderStep[]
  planType: 'archived' | 'none' | 'simulation' | 'operations'
  date?: string
}

export function Root(props: Props) {
  return (
    <Modal modalId={modalId}>
      <Content
        source={props.source}
        orderStepIds={props.orderStepIds}
        orderSteps={props.orderSteps}
        date={props.date}
        planType={props.planType}
      />
    </Modal>
  )
}
